import { register } from "@rill/loader";
import moment from "moment";
import getAvatarUrl from "../utils/get-avatar-url";

register(
  {
    name: "activityFeed",
  },
  async ({ api, locals }, query) => {
    const res = await api("client-activity", { query });
    const { limit } = query;
    const data = await res.json();
    const hasNextPage = data.length > limit - 1;
    if (hasNextPage) data.pop();
    const athletes =
      locals.allAthletesFromOrganization || locals.activeUser.athletes || [];

    const list = getActivitiesAndAthletes(
      data,
      athletes,
      locals.activeUser.webAppTheme
    );

    return { list, hasNextPage };
  }
);

const getActivitiesAndAthletes = (activities, athletes, webAppTheme) => {
  // Create a lookup map for athletes by their IDs
  const athleteMap = new Map();
  athletes.forEach((athlete) => {
    athleteMap.set(athlete._id, athlete);
    athleteMap.set(athlete.athleteId, athlete);
  });

  return activities?.map((activity) => {
    const athlete = athleteMap.get(activity.clientId);
    const { athleteName, name } = athlete || {};
    return {
      ...activity,
      athleteName: athleteName || name,
      athleteAvatar: getAvatarUrl(athlete, false, webAppTheme),
    };
  });
};
